import { graphql } from 'src/graphql';

export const CollectionsList = graphql(`
  query CollectionsList($filter: CollectionsFilter!, $first: Int = 30) {
    collections(filter: $filter, first: $first) {
      nodes {
        _id
        code
        title
        subtitle
        insight_ids
        short_name
        created_at
        created_by {
          displayName
        }
      }
    }
  }
`);
